<template>
  <div class='col-lg-3 col-md-6'>
    <div :class="'box box-' + type + ' box-solid collapsed-box'">
      <div class="box-header no-border">
        <h3 class="box-title">{{title | translate}}</h3>
        <div v-if="items.amount > 0" class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
        </div>
      </div>
      <div :class="'info-box bg-'+ type + '-active no-margin'">
        <span class="info-box-icon"><i :class="['fa', icon]"></i></span>
        <div class="info-box-content">
          <span class="info-box-text">
            {{items.items}}
            {{'items' | translate}}
          </span>
          <span class="info-box-number">
            {{items.orders}}
            <small> {{'orders' | translate}}</small>
          </span>
        </div>
      </div>
      <div class="box-body" style="display: none;">
        <ul class="list-group list-group-unbordered">
          <li class="list-group-item">
            <b>Ø {{'order_avg' | translate}}:</b> <span class="pull-right">{{items.average | currency}}</span>
          </li>
          <li class="list-group-item">
            <b>{{'total_amount' | translate}}:</b> <span class="pull-right">{{items.amount | currency}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items', 'type', 'title', 'icon'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
    items () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/OrderBoxesComponent.vue